<ng-container *transloco="let convert;">
<div class="edit-posting-form">
    <h3 class="content-card-title">{{convert('sellModule.posting.interiorForm.textInterior')}}</h3>
    <div class="content-card-subtitle">{{convert('sellModule.posting.interiorForm.textReviewOption')}}</div>

    <form class="body" name="interiorForm" nonvalidate (keydown.enter)="$event.preventDefault()">
        <div class="row mt-4">
            <div class="col-md-12">
                <div class="control-wrapper form-group">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input excludes__input" id="showAllOptions"
                            [attr.aria-label]="convert('sellModule.posting.interiorForm.ariaLabelShowAllOption')" data-track-name="Show All Options"
                            data-track-elem="check box"
                            [checked]="showAllOptions" (change)="toggleAllOptions()"/>
                        <label class="custom-control-label excludes__label" for="showAllOptions">{{convert('sellModule.posting.interiorForm.ariaLabelShowAllOption')}}</label>
                    </div>
                </div>
            </div>
        </div>
        <app-options-and-accessories-form [otherOptions]="otherOptions" (onUpdateInstalledOptions)="installOptions($event)" (onRemoveOptionUpdateAvailableOptions)="removeOption($event)">
        </app-options-and-accessories-form>
    </form>
</div>
</ng-container>
